import { createContext, useContext } from 'react';

export interface DiffEntry {
  type?: string;
  state?: string;
  computedDiff?: unknown;
  text?: string;
  data?: unknown;
  offset?: number;
  index?: number | null;
  key?: string;
  selected?: boolean;
}

export interface DiffState {
  left: Record<string, DiffEntry>;
  right: Record<string, DiffEntry>;
  leftSource: Record<string, unknown>;
  rightSource: Record<string, unknown>;
}

export interface DiffContextValue {
  diffState?: DiffState;
  setDiffState?: (state: DiffState) => void;
}

export const DiffContext = createContext<DiffContextValue>({});

export const useDiff = (): DiffContextValue => useContext(DiffContext);
